import * as React from 'react';
import * as _ from 'lodash';
import { hashHistory } from 'react-router';
export default function () {
    function onClick1() {
        hashHistory.push('/filters');
    }
    return React.createElement('div', { 'className': 'app-content-footer app-content-footer--fixed' }, React.createElement('div', { 'className': 'app-content-footer__buttons' }, React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': onClick1.bind(this)
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Filters Management'))));
}